import { KeysMatching } from 'framework/typescript-integration';

export function generateUniqueName<T>(items: T[], nameField: keyof T, template: string) {
	let maxIndex = 0,
		nameExists = false;
	const startsWith = `${template}-`;

	items.forEach((item) => {
		const nameFieldValue = item[nameField] as string;
		if (nameFieldValue.startsWith(startsWith)) {
			const len = startsWith.length;
			const strNumber = nameFieldValue.substring(len);
			const number = +strNumber;

			if (maxIndex < number) {
				maxIndex = number;
			}
		}

		if (nameFieldValue == template) nameExists = true;
	});

	if (maxIndex == 0 && !nameExists) return template;

	return startsWith + ++maxIndex;
}
